/**
 * Utility to handle blur events for searchable dropdowns.
 * Automatically closes dropdowns when their search inputs lose focus
 * and focus moves outside the dropdown container.
 */
/**
 * Checks if an element is a searchable dropdown input
 */
const isDropdownSearchInput = (element) => {
    if (!element || element.tagName !== "INPUT")
        return false;
    const inputElement = element;
    return (inputElement.type === "text" &&
        !!element.closest('[data-dropdown-container]'));
};
/**
 * Finds the dropdown container for a given input element
 */
const findDropdownContainer = (element) => {
    if (!element)
        return null;
    return element.closest('[data-dropdown-container]');
};
/**
 * Checks if the new focus target is within the dropdown container
 */
const isFocusWithinDropdown = (container, newFocusTarget) => {
    if (!container || !newFocusTarget)
        return false;
    const targetElement = newFocusTarget;
    return container.contains(targetElement);
};
/**
 * Closes the dropdown by dispatching a custom event
 * Components should listen for this event and close their dropdowns
 */
const closeDropdown = (container) => {
    const event = new CustomEvent('dropdown-blur-close', {
        bubbles: true,
        detail: { container }
    });
    container.dispatchEvent(event);
};
/**
 * Registers global blur handler for searchable dropdowns
 * Similar to registerPreventNumberWheel, this sets up a document-level listener
 */
export const registerDropdownBlur = () => {
    const handleBlur = (event) => {
        const target = event.target;
        // Only handle blur events from dropdown search inputs
        if (!isDropdownSearchInput(target))
            return;
        const container = findDropdownContainer(target);
        if (!container)
            return;
        // Use setTimeout to check where focus moved after blur completes
        setTimeout(() => {
            const newFocusTarget = document.activeElement;
            // If focus moved outside the dropdown container, close it
            if (!isFocusWithinDropdown(container, newFocusTarget)) {
                closeDropdown(container);
            }
        }, 0);
    };
    // Use capture phase to catch blur events early
    document.addEventListener("blur", handleBlur, true);
    return () => {
        document.removeEventListener("blur", handleBlur, true);
    };
};
